import './style.scss';

function ColumnsContainer({
  children,
  columnSeparation,
  className,
  marginTop,
  marginBottom,
  justifyContent,
  isFromSideoverlay = false,
}) {
  return (
    <div
      className={`ColumnsContainer columns-container columns-container-indi-compliance ${className || ''}`}
      style={{
        ...(columnSeparation && { gap: columnSeparation }),
        ...(marginTop && { marginTop }),
        ...(marginBottom && { marginBottom }),
        ...(justifyContent && { justifyContent }),
        ...(isFromSideoverlay && { position: 'relative', zIndex: 10 }),
      }}>
      {children}
    </div>
  );
}

export default ColumnsContainer;
